import axios from "axios";
import EndPoints from "../constants/endPoints";   
import { InvestorRequest } from "../models/request/investorRequest";
 
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ALMOWAZI_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const authToken = localStorage.getItem("token");
  if (authToken) {
    const tokenData = JSON.parse(atob(authToken.split(".")[1]));
    const tokenExp = tokenData.exp * 1000;
    const currentTime = new Date().getTime();

    if (tokenExp < currentTime) {
      localStorage.removeItem("token");
      localStorage.setItem("expired", "true");
      window.location.href = "/Signin";
    } else {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    return Promise.reject(error);
  }
);

const saveInvestor = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post(EndPoints.Investor.Save, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Failed to save investor:", error);
    throw new Error("Failed to save investor");
  }
};

const getInvestorById = async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.get(EndPoints.Investor.GetById, {
      params: { id },
    });
    return response;
  } catch (error) {
    console.error("Failed to get investor:", error);
    throw new Error("Failed to get investor");
  }
};

const registerInvestor = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      EndPoints.Investor.Register,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Failed to register investor:", error);
    throw new Error("Failed to register investor");
  }
};

const getInvestorList = async (data: InvestorRequest): Promise<any> => {
  try {
    const response = await axiosInstance.get(EndPoints.Investor.GetPageList, {
      params: data,
    });
    return response;
  } catch (error) {
    console.error("Failed to get investors:", error);
    throw new Error("Failed to get investors list");
  }
};

export const investorService = {
  saveInvestor,
  registerInvestor,
  getInvestorById,
  getInvestorList,
};
